module.exports = __webpack_public_path__ + "img/bg3.0a5ae91f.webp";